import React from 'react';
import { Link } from 'react-router-dom';

interface Breadcrumb {
  name: string;
  path?: string;
}

interface BreadcrumbsProps {
  crumbs: Breadcrumb[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ crumbs }) => {
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-1 text-sm text-gray-600">
        {crumbs.map((crumb, index) => (
          <li key={index} className="flex items-center">
            {crumb.path ? (
              <Link to={crumb.path} className="text-[#4F46E5] hover:underline">
                {crumb.name}
              </Link>
            ) : (
              <span className="text-gray-500">{crumb.name}</span>
            )}
            {index < crumbs.length - 1 && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 mx-1"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
